module.exports = __webpack_public_path__ + "static/media/tw.78aa6417.svg";